import lightTheme from 'js/common/themes/light-theme';
import darkTheme from 'js/common/themes/dark-theme';

export default function getTheme(theme) {

  const themes = {
    light: lightTheme(),
    dark: darkTheme()
  };

  return themes[theme]
}
